import type { CodeErrorResponse, CodeResponse } from '@/core/data/auth/google/oauth2';
import { ExternalLoader } from '@/core/helpers/external-loader';
import type { AuthScreenMethod } from '@/views/composables/auth/useAuth.interface';

const initGoogle = (cb: (loaded: boolean) => void): void => {
  if (window.google?.accounts) {
    cb(true);
    return;
  }

  new ExternalLoader(['https://accounts.google.com/gsi/client'], () => {
    cb(true);
  });
};

const googleSignIn = (
  method: AuthScreenMethod,
  cb: (codeResponse: CodeResponse) => void,
  onError: (error: CodeErrorResponse) => void,
): void => {
  // Built per attempt: a client whose popup was dismissed will not open another
  // one, and a cached client keeps calling back into an auth screen that may
  // have unmounted since.
  const client = window.google?.accounts.oauth2.initCodeClient({
    client_id: method.clientId || '',
    scope: 'profile email openid',
    ux_mode: 'popup',
    callback: cb,
    // Without this, a dismissed or blocked popup resolves nothing at all and
    // the button is left looking live while doing nothing.
    error_callback: onError,
  });

  client?.requestCode();
};

export default () => {
  return { initGoogle, googleSignIn };
};
